module.exports = __webpack_public_path__ + "img/lemon-right-4.ae7367b8.png";